import { useEffect, useState } from "react";
import {
  IChangePassFormValues,
  IGetTime,
  IGetUserInfo,
} from "../../Interfaces/headerInterfaces";
import {
  changePassword,
  getTime,
  getUserInfo,
} from "../../Requests/headerRequests";
import {
  changeCustomerPassword,
  getCurrentUserInfo,
} from "../../Requests/customerReportRequests";
import { toast } from "react-toastify";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { incrementSeconds } from "../../helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Tooltip } from "@mui/material";
import Modal from "../../Components/Modal/Modal";
import TextInput from "../../Components/TextInput";
import Button from "../../Components/Button";
// Hooks
import { useAppDispatch } from "src/App/hooks";
// Requests
import { getRiskProfileDropDown } from "src/Requests/coveredCall";
// Reducers
import { setRiskProfiles } from "src/Features/CoveredCall/CoveredCallSlice";

const UserInfoBox = ({
  isCustomer = false,
  customerDisplayName,
}: {
  isCustomer?: boolean;
  customerDisplayName?: string;
}) => {
  const [userInfo, setUserInfo] = useState<IGetUserInfo>({} as IGetUserInfo);
  const [displayName, setDisplayName] = useState("");
  const [dateAndTime, setDateAdTime] = useState<IGetTime>({} as IGetTime);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [changePassFormValues, setChangePassFormValues] =
    useState<IChangePassFormValues>({} as IChangePassFormValues);
  // hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    setLoading(true);
    if (isCustomer) {
      if (customerDisplayName !== undefined) {
        setDisplayName(customerDisplayName);
      } else {
        getCurrentUserInfo()
          .then(
            (resp) =>
              setDisplayName(resp.shownName ?? resp.sahraUser?.name ?? ""),
          )
          .catch(errorHandler);
      }
    } else {
      getUserInfoHandler();
      getRiskProfileDropDown().then((res) => {
        dispatch(setRiskProfiles([{ id: "0", name: "تجمیعی" }, ...res]));
      });
    }
    getTimeHandler();
    const myInterval = setInterval(() => {
      getTimeHandler();
    }, 60000);
    return () => clearInterval(myInterval);
  }, [isCustomer, customerDisplayName]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDateAdTime({
        ...dateAndTime,
        time: incrementSeconds(dateAndTime.time),
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, [dateAndTime.time]);

  function errorHandler(e: any) {
    let error: any = "";

    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    if (error === "") error = "خطا در ارتباط با سرور";
    toast.error(error);
  }

  const getTimeHandler = () => {
    getTime()
      .then((resp) => setDateAdTime(resp))
      .catch(errorHandler)
      .finally(() => setLoading(false));
  };

  const getUserInfoHandler = () => {
    getUserInfo()
      .then((resp) => setUserInfo(resp))
      .catch(errorHandler)
      .finally(() => setLoading(false));
  };

  const changeHandler = (name: string, value: any) => {
    setChangePassFormValues({ ...changePassFormValues, [name]: value });
  };

  const checkDisabled = () => {
    if (!changePassFormValues) return true;
    if (
      !changePassFormValues.password ||
      !changePassFormValues.oldPassword ||
      !changePassFormValues.confirmPassword
    )
      return true;
    if (changePassFormValues.confirmPassword !== changePassFormValues.password)
      return true;
    return false;
  };

  const changePassClickHandler = () => {
    setLoading(true);
    const changePasswordRequest = isCustomer
      ? changeCustomerPassword
      : changePassword;
    changePasswordRequest(changePassFormValues)
      .then((resp) => toast.success(resp.msg))
      .catch(errorHandler)
      .finally(() => setLoading(false));
  };

  const getModalUI = () => {
    return (
      <div className="flex flex-col justify-between items-center !h-52">
        <div className="flex flex-col justify-start items-center gap-3 w-full">
          <TextInput
            label="رمز عبور فعلی"
            name="oldPassword"
            value={changePassFormValues.oldPassword}
            onChange={changeHandler}
            type="password"
          />
          <TextInput
            label="رمز عبور جدید"
            name="password"
            value={changePassFormValues.password}
            onChange={changeHandler}
            type="password"
          />
          <TextInput
            label="تایید رمز عبور"
            name="confirmPassword"
            value={changePassFormValues.confirmPassword}
            onChange={changeHandler}
            type="password"
          />
        </div>
        <Button
          text="تایید"
          variant="contained"
          onClick={changePassClickHandler}
          disabled={checkDisabled()}
        />
      </div>
    );
  };

  const modalCloseHandler = () => {
    setChangePassFormValues({} as IChangePassFormValues);
    setIsOpen(false);
  };

  if (loading) return <FullScreenLoading />;

  return (
    <div className="bg-slate-100 max-w-min p-2 flex flex-row justify-start items-center gap-5 z-10">
      {isOpen ? <Modal title="تغییر رمز عبور" UI={getModalUI()} onClose={modalCloseHandler} /> : null}
      <div className="!text-gray-700 h-[120%]" onClick={() => setIsOpen(true)}>
        <Tooltip title="تغییر رمز عبور" arrow>
          <ManageAccountsIcon className="!text-md !text-gray-700" />
        </Tooltip>
      </div>
      <div className="whitespace-nowrap text-xs">
        {isCustomer ? displayName : userInfo.name}
      </div>
      <div className="text-xs">{dateAndTime.persianDate}</div>
      <div className="text-xs">{dateAndTime.time}</div>
      {!isCustomer && (
        <div
          className={`w-2 h-2 rounded-full ${
            userInfo.isOrderbookConnected ? "bg-green-800" : "bg-red-800"
          }`}
        />
      )}
    </div>
  );
};

export default UserInfoBox;
